import RpcService from "@/core/services/Rpc/RpcService";

import type RpcResponse from "@/core/services/Rpc/RpcResponse";
import type Demand      from "@/domains/Demand/Demand";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

class DemandsDAO {
  /**
   * Ищет товары по артикулам покупателя (demands.test).
   * partnerId на бэке берётся из текущего партнёра — клиент его не передаёт.
   */
  static async findProductsByCodes(codes: string[]): Promise<RpcResponse> {
    return await RpcService.makeRequest('demands.test', {
      demands: codes.map(code => ({ code: code.toString() })),
    });
  }

  /**
   * Загружает одну потребность по ID
   */
  static async get(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('demands.get', { id });
  }

  /**
   * Загружает список потребностей с фильтрацией и пагинацией
   */
  static async getList(
    filters?: {
      partnerId?: number;
      showAllPartners?: boolean;
      isBookmarked?: boolean;
      responsible?: number;
      product?: { id: number };
      category?: { id: number };
      hasTender?: boolean;
      desiredReceiptPeriod?: { start: Date; end: Date };
      pattern?: string;
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest(
      'demands.getList',
      {
        ...filters,
        responsible: filters?.responsible ? { id: filters.responsible } : undefined,
      },
      pagination,
      sort
    );
  }

  /**
   * Загружает список позиций потребности
   */
  static async getPositionList(params: {
    demandId?: number;
  }): Promise<RpcResponse> {
    return await RpcService.makeRequest('demands.getPositionList', params);
  }

	/**
     * Создаёт потребности
     */
    static async add(demands: Demand[]): Promise<RpcResponse> {
        return await RpcService.makeRequest('demands.add', { demands });
    }

    /**
     * Обновляет потребность
     */
    static async update(demand: Demand): Promise<RpcResponse> {
        return await RpcService.makeRequest('demands.update', { demand });
    }

    /**
     * Удаляет потребность по ID
     */
    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('demands.delete', { id });
    }
}

export default DemandsDAO;
